import React, { useEffect, useState } from 'react';

export const TerminalContext = React.createContext<{
  serverSideReaderID: string;
  setServerSideReaderID: (s: string) => void;
}>(null);

export type TerminalContextProviderProps = { children: React.ReactNode };

export const TerminalContextProvider: React.FC<
  TerminalContextProviderProps
> = ({ children }) => {
  const [serverSideReaderID, setServerSideReaderID] = useState('');

  const serReaderID = (readerID: string) => {
    localStorage.setItem('READER_ID', JSON.stringify(readerID));
    setServerSideReaderID(readerID);
  };

  useEffect(() => {
    const readerID = JSON.parse(localStorage.getItem('READER_ID')) || null;
    setServerSideReaderID(readerID);
  });

  return (
    <TerminalContext.Provider
      value={{
        serverSideReaderID,
        setServerSideReaderID: serReaderID
      }}
    >
      {children}
    </TerminalContext.Provider>
  );
};
